import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./Uniforms.css";

import uniformeInicial from "../../../assets/images/uniformes/uniformeinicial.png";
import uniformePrimario from "../../../assets/images/uniformes/uniformePrimario.png";
import uniformePrimarioEF from "../../../assets/images/uniformes/uniformePrimarioEF.png";
import uniformeSecundario from "../../../assets/images/uniformes/uniformeSecundario.png";
import uniformeSecundarioEF from "../../../assets/images/uniformes/uniformeSecundarioedf.png";

const uniformes = [
  {
    nivel: "Nivel Inicial",
    descripcion: "Uniforme oficial para alumnos del nivel inicial.",
    imagen: uniformeInicial,
  },
  {
    nivel: "Nivel Primario",
    descripcion: "Presentación institucional diaria para el nivel primario.",
    imagen: uniformePrimario,
  },
  {
    nivel: "Educación Física Primario",
    descripcion: "Indumentaria oficial para actividades deportivas de primaria.",
    imagen: uniformePrimarioEF,
  },
  {
    nivel: "Nivel Secundario",
    descripcion: "Uniforme institucional para alumnos del nivel secundario.",
    imagen: uniformeSecundario,
  },
  {
    nivel: "Educación Física Secundario",
    descripcion: "Equipo oficial para clases y actividades de educación física.",
    imagen: uniformeSecundarioEF,
  },
];

function Uniforms() {
  const [uniformeAmpliado, setUniformeAmpliado] = useState(null);

  return (
    <main className="uniforms-page">
      <section className="uniforms-hero uniforms-hero--info">
        <div className="uniforms-hero__copy">
          <span className="uniforms-eyebrow"></span>
          <h1>Uniformes Institucionales</h1>
          <p>Conocé los uniformes oficiales de cada nivel educativo.</p>
          <div className="uniforms-observations">
            <h2>Observaciones importantes</h2>
            <ul>
              <li>No se permiten prendas con logos, inscripciones, dibujos o colores que no correspondan a los mencionados.</li>
              <li>No se aceptará el uso de prendas deportivas que no sean del uniforme institucional.</li>
              <li>Se espera que los alumnos mantengan el uniforme limpio y en condiciones durante toda la jornada escolar.</li>
              <li>Todos los materiales, prendas y pertenencias deben tener el nombre del alumno en un lugar visible para evitar extravíos.</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="uniforms-carousel-section" aria-label="Carrusel de uniformes">
        <Carousel
          autoPlay
          infiniteLoop
          interval={4200}
          transitionTime={650}
          showThumbs={false}
          showStatus={false}
          swipeable
          emulateTouch
          renderArrowPrev={(clickHandler, hasPrev) =>
            hasPrev && (
              <button
                type="button"
                className="uniforms-carousel-arrow uniforms-carousel-arrow--prev"
                onClick={clickHandler}
                aria-label="Uniforme anterior"
              >
                ‹
              </button>
            )
          }
          renderArrowNext={(clickHandler, hasNext) =>
            hasNext && (
              <button
                type="button"
                className="uniforms-carousel-arrow uniforms-carousel-arrow--next"
                onClick={clickHandler}
                aria-label="Uniforme siguiente"
              >
                ›
              </button>
            )
          }
        >
          {uniformes.map((uniforme) => (
            <article className="uniforms-slide" key={uniforme.nivel}>
              <div className="uniforms-slide__image">
                <img src={uniforme.imagen} alt={uniforme.nivel} />
              </div>
              <div className="uniforms-slide__content">
                <span>Uniforme oficial</span>
                <h2>{uniforme.nivel}</h2>
                <p>{uniforme.descripcion}</p>
              </div>
            </article>
          ))}
        </Carousel>
      </section>

      <section className="uniforms-grid" aria-label="Niveles educativos">
        {uniformes.map((uniforme) => (
          <article className="uniform-card" key={uniforme.nivel}>
            <button
              type="button"
              className="uniform-card__image"
              onClick={() => setUniformeAmpliado(uniforme)}
              aria-label={`Ampliar imagen de ${uniforme.nivel}`}
            >
              <img src={uniforme.imagen} alt={uniforme.nivel} />
            </button>
            <div>
              <h3>{uniforme.nivel}</h3>
              <p>{uniforme.descripcion}</p>
            </div>
          </article>
        ))}
      </section>

      <section className="uniforms-cta">
        <div>
          <h2>¿Tenés dudas sobre los uniformes?</h2>
          <p>Comunicate con el colegio para recibir orientación sobre talles, prendas y niveles.</p>
        </div>
        <a
          href="https://wa.me/5492954313911?text=Hola%2C%20quiero%20consultar%20por%20los%20uniformes%20del%20colegio."
          target="_blank"
          rel="noopener noreferrer"
          className="uniforms-whatsapp"
        >
          Consultar Uniformes
        </a>
      </section>

      {uniformeAmpliado && (
        <div
          className="uniform-modal"
          role="dialog"
          aria-modal="true"
          aria-label={`Imagen ampliada de ${uniformeAmpliado.nivel}`}
          onClick={() => setUniformeAmpliado(null)}
        >
          <div className="uniform-modal__content" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              className="uniform-modal__close"
              onClick={() => setUniformeAmpliado(null)}
              aria-label="Cerrar imagen ampliada"
            >
              ×
            </button>
            <img src={uniformeAmpliado.imagen} alt={uniformeAmpliado.nivel} />
            <h2>{uniformeAmpliado.nivel}</h2>
            <p>{uniformeAmpliado.descripcion}</p>
          </div>
        </div>
      )}
    </main>
  );
}

export default Uniforms;
